import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'

// https://doc2.ixiaochuan.cn/pages/viewpage.action?pageId=41444838
const initialState: {
  order_id?: string
  pub_key?: string
} = {}

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=110332023
export const checkout_get_ext_info = createAsyncThunk(
  '/live/pay/checkout_get_ext_info',
  async (order_id: string, store) => {
    const resp = await http.post<HiyaRes<typeof initialState>>(
      '/live/pay/checkout_get_ext_info',
      store.getState().env.deviceinfo
    )
    return resp.data.data
  }
)

// http://wiki.xunlei.cn/pages/viewpage.action?pageId=110332036
export const create_checkout_order = createAsyncThunk(
  '/live/pay/create_checkout_order',
  async (
    data: {
      order_id: string
      token: string
      event: any
    },
    store
  ) => {
    const resp = await http.post<
      HiyaRes<{
        redirect_url: string
      }>
    >('/live/pay/create_checkout_order', {
      ...store.getState().env.deviceinfo,
      ...data,
    })
    return resp.data.data
  }
)
export const Wallet2CheckoutSlice = createSlice({
  name: 'Wallet2Checkout',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(checkout_get_ext_info.fulfilled, (state, action) => {
      Object.assign(state, {
        ...action.payload,
        order_id: action.meta.arg,
      })
    })
  },
})
export const Wallet2CheckoutSliceActions = Wallet2CheckoutSlice.actions
export default Wallet2CheckoutSlice.reducer
export const useWallet2CheckoutState = () => {
  const data = useSelector((state) => state.Wallet2Checkout)
  return data
}
